import { Grid, IconButton, Typography } from "@biggeo/bg-ui/lab";
import {
    ChevronLeftOutline,
    ChevronRightOutline,
    ExpandLessOutline,
    ExpandMoreOutline,
} from "@biggeo/bg-ui/lab/icons";
import React from "react";

export type MapLayoutHeaderProps = {
    inverted?: boolean;
    vertical?: boolean;
    header: string;
    onClick: () => void;
    customHeader?: React.ReactNode;
};

export const MapLayoutHeader = ({
    inverted = false,
    vertical = true,
    header,
    onClick,
    customHeader,
}: MapLayoutHeaderProps) => {
    return (
        <Grid
            container
            alignItems="center"
            flexWrap="nowrap"
            flexDirection={inverted ? "row-reverse" : undefined}
            gap={2}
            sx={{
                padding: 2,
                borderBottom: 1,
                borderColor: (theme) => theme.palette.stroke[100],
            }}
        >
            {customHeader ? (
                customHeader
            ) : (
                <Grid item xs minWidth={0}>
                    <Typography variant="title3" fontWeight="bold" truncate>
                        {header}
                    </Typography>
                </Grid>
            )}
            <IconButton
                variant="ghost"
                onClick={onClick}
                sx={{
                    transform: "rotate(-90deg)",
                    breakpoints: {
                        cmd: {
                            transform: "none",
                        },
                    },
                }}
            >
                {vertical ? (
                    inverted ? (
                        <ChevronRightOutline size="xs" />
                    ) : (
                        <ChevronLeftOutline size="xs" />
                    )
                ) : inverted ? (
                    <ExpandLessOutline size="xs" />
                ) : (
                    <ExpandMoreOutline size="xs" />
                )}
            </IconButton>
        </Grid>
    );
};
